import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => localStorage.getItem("ktt_dark") === "1");
  const [palette, setPalette] = useState(() => localStorage.getItem("ktt_palette") || "suleymaniye");

  useEffect(() => {
    const el = document.documentElement;
    el.classList.toggle("dark", dark);
    el.setAttribute("data-palette", palette);
    localStorage.setItem("ktt_dark", dark ? "1" : "0");
    localStorage.setItem("ktt_palette", palette);
  }, [dark, palette]);

  return (
    <ThemeContext.Provider value={{ dark, setDark, palette, setPalette }}>
      {children}
    </ThemeContext.Provider>
  );
}
